import styles from './index.module.scss';
import { fabric } from 'fabric';
import { useEffect, useRef, useState } from 'react';
import useCanvasZoom from './hooks/useCanvasZoom';
import useCanvasMovement from './hooks/useCanvasMovement';
import { RESIZE_IMG_CANVASNAME } from '@utils/CONST'


const CanvasPreLoad = (props) => {
    const { imageUrl } = props
    const isMounted = useRef(null);
    const canvasRef = useRef(null);
    const canvasInstance = useRef(null);
    const [zoom, setZoom] = useState();
    const [imgWidth, setImgWidth] = useState()
    const [imgHeight, setImgHeight] = useState()

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const initCanvas = () => {
        if (!canvasRef.current) return
        const container = canvasRef.current.parentElement;
        const { width, height } = container.getBoundingClientRect();
        if (canvasInstance.current) {
            canvasInstance.current.dispose();
        }
        canvasInstance.current = new fabric.Canvas(canvasRef.current, {
            width,
            height,
            backgroundColor: '#fff',
            selection: false,
            defaultCursor: 'grab',
        })
    };

    const [scaleInit, setScaleInit] = useState()

    const loadImage = (url) => {
        if (!canvasInstance.current) return;

        fabric.Image.fromURL(url, (img) => {
            if (!canvasRef.current) return
            const container = canvasRef.current.parentElement;
            const originalWidth = img.width;
            const originalHeight = img.height;
            setImgWidth(originalWidth)
            setImgHeight(originalHeight)
            // 计算基于容器短边的缩放比例
            const containerRatio = container.clientWidth / container.clientHeight;
            const imageRatio = originalWidth / originalHeight;
            let scale = 1;
            if (originalWidth > container.clientWidth || originalHeight > container.clientHeight) {
                if (containerRatio > imageRatio) {
                    scale = container.clientHeight / originalHeight;
                } else {
                    scale = container.clientWidth / originalWidth;
                }
            }

            setScaleInit(scale)
            const leftPoint = (container.clientWidth - originalWidth * scale) / 2
            const topPoint = (container.clientHeight - originalHeight * scale) / 2

            canvasInstance.current.zoomToPoint({
                x: leftPoint,
                y: topPoint
            }, scale);

            img.set({
                left: leftPoint,
                top: topPoint,
                selectable: false,
                evented: false,
                hasControls: false,
                hasBorders: false,
                lockMovementX: false,
                lockMovementY: false,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true
            });
            canvasInstance.current.clear();
            canvasInstance.current.add(img);
            canvasInstance.current.renderAll();
        });
    };

    // 处理窗口大小变化
    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            if (!canvasInstance.current) return;

            const { width, height } = entries[0].contentRect;
            canvasInstance.current.setDimensions({ width, height });
            canvasInstance.current.requestRenderAll();
        });

        const parentDiv = canvasRef.current.parentElement;
        if (parentDiv) {
            resizeObserver.observe(parentDiv);
        }
    }, []);


    useEffect(() => {
        if (!imageUrl) return
        initCanvas();
        loadImage(imageUrl);
    }, [imageUrl]);

    const onMove = () => {

    }

    // 移动画布
    useCanvasMovement(canvasInstance, ({ left, top }) => {
        onMove({ left, top })
    });

    const onZoom = (scale) => {
        setZoom(scale)
    }

    // 处理缩放
    useCanvasZoom(
        canvasInstance,
        null,
        zoom, onZoom,
        scaleInit,
        RESIZE_IMG_CANVASNAME.SCROLL_CANVAS
    )

    return (
        <div className={styles.canvasPreLoad}>
            <canvas ref={canvasRef} />
        </div>
    );
};

export default CanvasPreLoad;